import { Component, OnInit, OnDestroy } from "@angular/core";

import { DataService_viewvisitor } from "../shared/data.service";

import { wsVPPAdminVisitorEditDataParm } from "../shared/wsVPPAdminVisitorEditDataParm";
import { wsVPPAdminVisitorEditDataInfo } from "../shared/wsVPPAdminVisitorEditDataInfo";
import { wsVPPAdminVisitorEditDataFacilityInfo } from "../shared/wsVPPAdminVisitorEditDataInfo";
import { wsVPPAdminVisitorEditDataTypeInfo } from "../shared/wsVPPAdminVisitorEditDataInfo";
import { wsVPPAdminVisitorEditDataStatusInfo } from "../shared/wsVPPAdminVisitorEditDataInfo";
import { wsVPPAdminVisitorEditDataGenderInfo } from "../shared/wsVPPAdminVisitorEditDataInfo";
import { wsVPPAdminVisitorEditDataEthnicityInfo } from "../shared/wsVPPAdminVisitorEditDataInfo";
import { wsVPPAdminVisitorEditDataRaceInfo } from "../shared/wsVPPAdminVisitorEditDataInfo";
import { wsVPPAdminVisitorEditAddBlockedParm } from "../shared/wsVPPAdminVisitorEditAddBlockedParm";
import { wsVPPAdminVisitorEditModifyParm } from "../shared/wsVPPAdminVisitorEditModifyParm";

import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";

@Component({
	selector: "app-root",
	templateUrl: "./editvisitor.component.html",
	styleUrls: ["./editvisitor.component.css"],
	providers: [ConfirmationService],
})
export class EditVisitorComponent implements OnInit, OnDestroy {
	constructor(
		private dataService: DataService_viewvisitor,
		public ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		public dialogConfig: DynamicDialogConfig
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	public isBusy: boolean = false;

	public UserID: number;
	public UserLevelID: number;
	public Visitor_PersonID: number;

	public selectedGroupValue: string = "1";

	public VPPAdminVisitorEditData: wsVPPAdminVisitorEditDataInfo;

	public lstFacilityItems: wsVPPAdminVisitorEditDataFacilityInfo[] = [];
	public SelectedFacility: wsVPPAdminVisitorEditDataFacilityInfo;

	public lstTypeItems: wsVPPAdminVisitorEditDataTypeInfo[] = [];
	public SelectedType: wsVPPAdminVisitorEditDataTypeInfo;

	public lstStatusItems: wsVPPAdminVisitorEditDataStatusInfo[] = [];
	public SelectedStatus: wsVPPAdminVisitorEditDataStatusInfo;

	public lstGenderItems: wsVPPAdminVisitorEditDataGenderInfo[] = [];
	public SelectedGender: wsVPPAdminVisitorEditDataGenderInfo;

	public lstEthnicityItems: wsVPPAdminVisitorEditDataEthnicityInfo[] = [];
	public SelectedEthnicity: wsVPPAdminVisitorEditDataEthnicityInfo;

	public lstRaceItems: wsVPPAdminVisitorEditDataRaceInfo[] = [];
	public SelectedRace: wsVPPAdminVisitorEditDataRaceInfo;

	public rFirstName: string = "";
	public rMiddleName: string = "";
	public rLastName: string = "";
	public rDOB: Date = null;
	public rSSN: string = "";
	public rStreet1: string = "";
	public rStreet2: string = "";
	public rCity: string = "";
	public rState: string = "";
	public rZip: string = "";
	public rCellPhone: string = "";
	public rHomePhone: string = "";
	public rWorkPhone: string = "";
	public rEmail: string = "";
	public rEyeColor: string = "";
	public rHairColor: string = "";
	public rHeight: string = "";
	public rWeight: string = "";
	public PersonImageID: number = -1;
	public Person_Image: string = "";
	public isPersonImageChanged: boolean = false;
	public isAllowStatusChange: boolean = true;

	public ErrorMessage: string = "";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.isBusy = true;

		this.UserID = this.dialogConfig.data.UserID;
		this.UserLevelID = this.dialogConfig.data.UserLevelID;
		this.Visitor_PersonID = this.dialogConfig.data.Visitor_PersonID;
		this.isAllowStatusChange = this.dialogConfig.data.isAllowStatusChange;

		if (this.UserLevelID == 1) {
			// District Level
			this.selectedGroupValue = "1";
		} else {
			this.selectedGroupValue = "2";
		}

		let parms: wsVPPAdminVisitorEditDataParm = {
			UserID: this.UserID,
			Visitor_PersonID: this.Visitor_PersonID,
		};

		this.isBusy = true;
		this.dataService.VPPAdminVisitorEditDataGet(parms).subscribe((data) => this.VPPAdminVisitorEditDataGet_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnDestroy() {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	VPPAdminVisitorEditDataGet_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	VPPAdminVisitorEditDataGet_Complete(data: any) {
		this.VPPAdminVisitorEditData = data;

		this.lstFacilityItems = this.VPPAdminVisitorEditData.FacilityItems;
		this.lstTypeItems = this.VPPAdminVisitorEditData.TypeItems;
		this.lstStatusItems = this.VPPAdminVisitorEditData.StatusItems;
		this.lstGenderItems = this.VPPAdminVisitorEditData.GenderItems;
		this.lstEthnicityItems = this.VPPAdminVisitorEditData.EthnicityItems;
		this.lstRaceItems = this.VPPAdminVisitorEditData.RaceItems;

		this.rFirstName = this.VPPAdminVisitorEditData.VisitorRecord.FirstName;
		this.rLastName = this.VPPAdminVisitorEditData.VisitorRecord.LastName;
		this.rMiddleName = this.VPPAdminVisitorEditData.VisitorRecord.MiddleName;

		if (this.VPPAdminVisitorEditData.VisitorRecord.DOB == null) {
			this.rDOB = null;
		} else {
			this.rDOB = new Date(this.VPPAdminVisitorEditData.VisitorRecord.DOB); // Must do new for this to work
		}

		this.rSSN = this.VPPAdminVisitorEditData.VisitorRecord.SSN;
		this.rStreet1 = this.VPPAdminVisitorEditData.VisitorRecord.Street1;
		this.rStreet2 = this.VPPAdminVisitorEditData.VisitorRecord.Street2;
		this.rCity = this.VPPAdminVisitorEditData.VisitorRecord.City;
		this.rState = this.VPPAdminVisitorEditData.VisitorRecord.State;
		this.rZip = this.VPPAdminVisitorEditData.VisitorRecord.Zip;
		this.rCellPhone = this.VPPAdminVisitorEditData.VisitorRecord.CellPhone;
		this.rHomePhone = this.VPPAdminVisitorEditData.VisitorRecord.HomePhone;
		this.rWorkPhone = this.VPPAdminVisitorEditData.VisitorRecord.WorkPhone;
		this.rEmail = this.VPPAdminVisitorEditData.VisitorRecord.Email;
		this.rEyeColor = this.VPPAdminVisitorEditData.VisitorRecord.EyeColor;
		this.rHairColor = this.VPPAdminVisitorEditData.VisitorRecord.HairColor;
		this.rHeight = this.VPPAdminVisitorEditData.VisitorRecord.Height;
		this.rWeight = this.VPPAdminVisitorEditData.VisitorRecord.Weight;
		this.PersonImageID = this.VPPAdminVisitorEditData.VisitorRecord.PersonImageID;
		this.Person_Image = this.VPPAdminVisitorEditData.VisitorRecord.Person_Image;

		//
		//	Set Default Date For Add Visitor
		//
		if (this.Visitor_PersonID == -1) {
			this.rDOB = null;
		}

		//
		//	Select Default Facility
		//
		this.SelectedFacility = this.lstFacilityItems[0];

		//
		//	Select Default Type
		//
		this.SelectedType = this.lstTypeItems[0];

		this.lstTypeItems.forEach((item) => {
			if (this.Visitor_PersonID == -1 && this.isAllowStatusChange == false) {
				if (item.VisitorTypeID == 3) {
					// Other
					this.SelectedType = item;
				}
			} else {
				if (item.VisitorTypeID == this.VPPAdminVisitorEditData.VisitorRecord.VisitorTypeID) {
					this.SelectedType = item;
				}
			}
		});

		//
		//	Select Default Status
		//
		this.SelectedStatus = this.lstStatusItems[0];

		this.lstStatusItems.forEach((item) => {
			if (this.Visitor_PersonID == -1 && this.isAllowStatusChange == false) {
				if (item.VisitorStatusID == 2) {
					// Deny Entry
					this.SelectedStatus = item;
				}
			} else {
				if (item.VisitorStatusID == this.VPPAdminVisitorEditData.VisitorRecord.VisitorStatusID) {
					this.SelectedStatus = item;
				}
			}
		});

		//
		//	Select Default Gender
		//
		this.lstGenderItems.unshift({
			GenderID: -1,
			GenderCD: "",
			GenderDesc: "- Not Specified -",
		});

		this.SelectedGender = this.lstGenderItems[0];

		this.lstGenderItems.forEach((item) => {
			if (item.GenderCD.toLowerCase() == this.VPPAdminVisitorEditData.VisitorRecord.GenderCD.toLowerCase()) {
				this.SelectedGender = item;
			}
		});

		//
		//	Select Default Ethnicity
		//
		this.lstEthnicityItems.unshift({
			EthnicityID: -1,
			EthnicityDesc: "- Not Specified -",
		});

		this.SelectedEthnicity = this.lstEthnicityItems[0];

		this.lstEthnicityItems.forEach((item) => {
			if (item.EthnicityID == this.VPPAdminVisitorEditData.VisitorRecord.EthnicityID) {
				this.SelectedEthnicity = item;
			}
		});

		//
		//	Select Default Race
		//
		this.lstRaceItems.unshift({
			RaceID: -1,
			RaceDesc: "- Not Specified -",
		});

		this.SelectedRace = this.lstRaceItems[0];

		this.lstRaceItems.forEach((item) => {
			if (item.RaceID == this.VPPAdminVisitorEditData.VisitorRecord.RaceID) {
				this.SelectedRace = item;
			}
		});

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onEditPhoto
	//
	//-----------------------------------------------------------------------------------------------------
	onEditPhoto(event: any) {
		console.log("Starting image load..", new Date().toLocaleTimeString("en-US"));

		if (event.target.files && event.target.files[0]) {
			let reader = new FileReader();

			reader.onload = (e: any) => {
				this.ResizeImageAndUpload(event.target.files[0], e.target.result, 640, this);
			};

			reader.readAsDataURL(event.target.files[0]);
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ResizeImageAndUpload
	//
	//-----------------------------------------------------------------------------------------------------
	ResizeImageAndUpload(imgfile: any, imgfiledata: any, MAX_SIZE: any, _this: this) {
		// Create work image for resizing
		let img = document.createElement("img");

		img.onerror = function () {
			console.log("ERROR: Invalid Image! -> ", imgfile.name);
		};

		img.onload = function () {
			let width = img.width;
			let height = img.height;

			if (width >= height) {
				// Landscape
				height = Math.round(img.height * (MAX_SIZE / img.width));
				width = MAX_SIZE;
			} else {
				// Portrait
				width = Math.round(img.width * (MAX_SIZE / img.height));
				height = MAX_SIZE;
			}

			let canvas = document.createElement("canvas");

			canvas.width = width;
			canvas.height = height;

			let ctx = canvas.getContext("2d");

			ctx.drawImage(img, 0, 0, width, height);

			_this.Person_Image = canvas.toDataURL("image/jpeg");
			_this.isPersonImageChanged = true;

			console.log("Image load complete..", new Date().toLocaleTimeString("en-US"));
		};

		// Load The Image Data
		img.src = imgfiledata;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onGroupChange
	//
	//-----------------------------------------------------------------------------------------------------
	onGroupChange(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onDOBChange
	//
	//-----------------------------------------------------------------------------------------------------
	onDOBChange(val) {
		this.rDOB = val;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onFacilityChange
	//
	//-----------------------------------------------------------------------------------------------------
	onFacilityChange(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onTypeChange
	//
	//-----------------------------------------------------------------------------------------------------
	onTypeChange(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onStatusChange
	//
	//-----------------------------------------------------------------------------------------------------
	onStatusChange(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onGenderChange
	//
	//-----------------------------------------------------------------------------------------------------
	onGenderChange(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onEthnicityChange
	//
	//-----------------------------------------------------------------------------------------------------
	onEthnicityChange(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRaceChange
	//
	//-----------------------------------------------------------------------------------------------------
	onRaceChange(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onUpdate
	//
	//-----------------------------------------------------------------------------------------------------
	onUpdate() {
		this.ErrorMessage = "";

		//
		//	Validation
		//
		if (this.rFirstName.trim().length == 0 || this.rLastName.trim().length == 0) {
			this.ErrorMessage = "First Name and Last Name are required fields.";
			return;
		}

		if (this.rDOB != null) {
			if (this.rDOB.getFullYear() < 1753) {
				// SQL Does not support dates < 1753
				this.ErrorMessage = "Invalid DOB. Date must be greater then 1/1/1753.";
				return;
			}
		}

		//
		//	Validation Passed / Do AddBlocked or UpdateSelectedVisitor
		//
		if (this.Visitor_PersonID <= 0) {
			//
			//	Add Blocked
			//
			let workFacilityID = -1;

			if (this.selectedGroupValue == "2") {
				workFacilityID = this.SelectedFacility.FacilityID;
			}

			let parms: wsVPPAdminVisitorEditAddBlockedParm = {
				FacilityID: workFacilityID,
				FirstName: this.rFirstName,
				MiddleName: this.rMiddleName,
				LastName: this.rLastName,
				VisitorTypeID: this.SelectedType.VisitorTypeID,
				EthnicityID: this.SelectedEthnicity.EthnicityID,
				RaceID: this.SelectedRace.RaceID,
				Email: this.rEmail,
				SSN: this.rSSN,
				GenderCD: this.SelectedGender.GenderCD,
				DOB: this.rDOB,
				Street1: this.rStreet1,
				Street2: this.rStreet2,
				City: this.rCity,
				State: this.rState,
				Zip: this.rZip,
				HomePhone: this.rHomePhone,
				CellPhone: this.rCellPhone,
				WorkPhone: this.rWorkPhone,
				Height: this.rHeight,
				Weight: this.rWeight,
				EyeColor: this.rEyeColor,
				HairColor: this.rHairColor,
				Person_Image: this.Person_Image,
			};

			this.isBusy = true;
			this.dataService.VPPAdminEditVisitorAddBlocked(parms).subscribe((data) => this.VPPAdminEditVisitorAddBlocked_Complete(data));
		} else {
			//
			//	Edit Selected
			//
			let parms: wsVPPAdminVisitorEditModifyParm = {
				PersonID: this.Visitor_PersonID,
				FirstName: this.rFirstName,
				MiddleName: this.rMiddleName,
				LastName: this.rLastName,
				VisitorStatusID: this.SelectedStatus.VisitorStatusID,
				VisitorTypeID: this.SelectedType.VisitorTypeID,
				EthnicityID: this.SelectedEthnicity.EthnicityID,
				RaceID: this.SelectedRace.RaceID,
				Email: this.rEmail,
				SSN: this.rSSN,
				GenderCD: this.SelectedGender.GenderCD,
				DOB: this.rDOB,
				Street1: this.rStreet1,
				Street2: this.rStreet2,
				City: this.rCity,
				State: this.rState,
				Zip: this.rZip,
				HomePhone: this.rHomePhone,
				CellPhone: this.rCellPhone,
				WorkPhone: this.rWorkPhone,
				Height: this.rHeight,
				Weight: this.rWeight,
				EyeColor: this.rEyeColor,
				HairColor: this.rHairColor,
				isPersonImageChanged: this.isPersonImageChanged,
				PersonImageID: this.PersonImageID,
				Person_Image: this.Person_Image,
			};

			this.isBusy = true;
			this.dataService.VPPAdminEditVisitorEdit(parms).subscribe((data) => this.VPPAdminEditVisitorEdit_Complete(data));
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	VPPAdminEditVisitorAddBlocked_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	VPPAdminEditVisitorAddBlocked_Complete(data: any) {
		this.isBusy = false;
		this.ErrorMessage = data[0];

		//
		// 0 = CANCEL; 1 = SAVE
		//
		if (this.ErrorMessage.length == 0) {
			this.ref.close(1);
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	VPPAdminEditVisitorEdit_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	VPPAdminEditVisitorEdit_Complete(data: any) {
		this.isBusy = false;
		this.ErrorMessage = data[0];

		//
		// 0 = CANCEL; 1 = SAVE
		//
		if (this.ErrorMessage.length == 0) {
			this.ref.close(1);
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClose
	//
	//-----------------------------------------------------------------------------------------------------
	onClose() {
		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(0);
	}
}
